export const CharityLocation = ({
  city,
  state,
}: {
  city: string;
  state: string;
}) => {
  return (
    <div className="tw:flex tw:items-center">
      <div className="tw:mb-0 tw:text-gray-700 tw:text-base">{`${city}, ${state}`}</div>
    </div>
  );
};
